import React, { useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { Box, IconButton, Tooltip } from "@material-ui/core";
import InfoIcon from "@material-ui/icons/Info";
import { theme as themeConfig } from "../../themes/themes";

const TooltipComponent = ({ keyId, descriptionText }) => {
  const [showTooltipDescription, setShowTooltipDescription] = useState(false);
  return (
    <>
      <Tooltip
        style={{ padding: "3px" }}
        placement="right"
        open={showTooltipDescription}
        title={
          <>
            <Box
              style={{
                margin: "0",
                listStyleType: "circle",
                lineHeight: "1.3",
                fontSize: "13px",
              }}
            >
              <span>{descriptionText}</span>
            </Box>
          </>
        }
        arrow
      >
        <IconButton
          onClick={() => {
            setShowTooltipDescription(!showTooltipDescription);
          }}
        >
          <InfoIcon
            fontSize="small"
            style={{
              cursor: "pointer",
              color: themeConfig.text.primary,
              width: "18px",
              height: "18px",
            }}
          />
        </IconButton>
      </Tooltip>
    </>
  );
};

export default TooltipComponent;
